import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./NewInjuryPage.css";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab from "../Components/DocPage/new-tab/page-docs-tab";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import { fetchInjuryPageData } from "../Redux/injuries/actions";
import BodyPartsTab from "../Components/InjuriesDashboard/new-injury-page/body-parts-tab";
import TabsComponentNotesLevel from "../Components/TreatmentPage/TabsComponentNotesLevel";

const PAGE_TITLES = {
  bodyParts: "Body Parts",
  diagnoses: "Diagnoses",
  pathogens: "Pathogens",
  conditions: "Conditions",
  photo: "Photos",
};

// const PHOTO_ICON_URL =
//   "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const PageTitle = ({ currentPage }) => (
  <div
    style={{
      width: "100%",
      justifyContent: "flex-start",
      background: "var(--primary)",
      height: "25px",
      marginBottom: "5px",
    }}
  >
    <span
      className="fw-bold text-white"
      style={{
        height: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {PAGE_TITLES[currentPage]}
    </span>
  </div>
);

const PageContent = ({ currentPage, injuriesData, pageName, pageIcon }) => {
  switch (currentPage) {
    // Employment MainTab use it for previous work
    case "bodyParts":
      return <BodyPartsTab injuriesData={injuriesData} />;
    case "diagnoses":
      return <></>;
    case "pathogens":
      return <></>;
    case "conditions":
      return <></>;
    case "photo":
      return <PhotoTab pageId={7} pageName={"Injury"} />;
    case "docs":
      return (
        <PageDocsTab
          key={`${getClientId()}-${getCaseId()}`}
          pageId={7}
          pageName={pageName}
          pageIcon={pageIcon}
        />
      );
    default:
      return null;
  }
};

const NewInjuryPage = () => {
  const [currentPage, setCurrentPage] = useState("bodyParts");
  const dispatch = useDispatch();
  const clientId = getClientId();
  const caseId = getCaseId();

  const { injuriesData } = useSelector((state) => state.injuries);
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 7).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    fetchInjuryPageData(dispatch);
    fetchShakespeareStatus(caseId, 7, dispatch);
  }, [caseId, clientId, dispatch]);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const mainTabs = useMemo(
    () => [
      {
        id: "bodyParts",
        label: "Body Parts",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("bodyParts"),
        leftHand: false,
      },
      {
        id: "diagnoses",
        label: "Diagnoses",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("diagnoses"),
        leftHand: false,
      },
      {
        id: "pathogens",
        label: "Pathogens",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("pathogens"),
        leftHand: false,
      },
      {
        id: "conditions",
        label: "Conditions",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("conditions"),
        leftHand: false,
      },
    ],
    [handlePageChange]
  );

  const photoTabs = useMemo(
    () => [
      {
        id: "docs",
        label: "Docs",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("docs"),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/documents-icon-color_b6TvcB7.svg"
              width={15}
              height={15}
              alt=""
            />
          </span>
        ),
      },
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );
  const attachmentTabs = usePageAttachmentTabs(7, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="7" client={injuriesData?.client} />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <div className="d-flex align-items-center" style={{ paddingRight: "191px" }}>
              <div style={{ flex: "1 1 0", minWidth: 0 }}>
                <TabsComponentNotesLevel
                  handlePage={currentPage}
                  tabsData={mainTabs}
                  height={25}
                  labelClass=" justify-content-start ps-0"
                />
              </div>

              <div style={{ flexShrink: 0 }}>
                <TabsComponentNotesLevel
                  handlePage={currentPage}
                  controlledActiveTab={true}
                  tabsData={attachmentTabs}
                  height={25}
                  labelClass="justify-content-end"
                />
              </div>
            </div>

            {currentPage !== "docs" && currentPage !== "photo" && (
              <PageTitle currentPage={currentPage} />
            )}
            <PageContent
              currentPage={currentPage}
              injuriesData={injuriesData}
              pageName={pageObject?.name}
              pageIcon={pageObject?.page_icon}
            />

            <NotesSectionDashboard pageName={"Injury"} />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default React.memo(NewInjuryPage);
